import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  FormControl,
  FormLabel,
  GridItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Textarea,
  Text,
  useToast,
} from "@chakra-ui/react";
import client from "../../../../../helpers/Client";
import { useNavigate } from "react-router-dom";
import urlToId from "../../../../../helpers/UrlToId";

export default function CreateServiceModal({
  task,
  revalidator,
  state,
  onClose,
}) {
  const [services, setServices] = useState([]); // State to hold all service cards
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [scrollBehavior] = React.useState("inside");
  const [productOptions, setProductOptions] = useState([]);
  const [errorData, setErrorData] = useState({});
  const toast = useToast();

  useEffect(() => {
    async function fetchProductOptions() {
      try {
        const response = await client.get("/models/");
        setProductOptions(response.data);
      } catch (error) {
        console.error("Error fetching product options:", error);
      }
    }
    fetchProductOptions();
  }, []);

  const handleAddService = () => {
    setServices((prevServices) => [
      ...prevServices,
      {
        product: "",
        type: "",
        body: "",
      },
    ]);
  };

  const handleRemoveService = (index) => {
    setServices((prevServices) => prevServices.filter((_, i) => i !== index));
  };

  const handleChangeService = (index, key, value) => {
    setServices((prevServices) =>
      prevServices.map((service, i) =>
        i === index ? { ...service, [key]: value } : service
      )
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const servicePromises = services.map((service) =>
        client.post(`/service_records/`, {
          task: `${task.url}`,
          product_model: service.product,
          product: null,
          desc: service.body,
          service_type: service.type,
        })
      );
      const responses = await Promise.all(servicePromises);
      setLoading(false);
      revalidator.revalidate();
      state.onClose();
      navigate("/servis/" + urlToId(responses[0].data.url) + "/");
    } catch (error) {
      setErrorData(error.response.data);
      setLoading(false);
      if (error.response.data.non_field_errors) {
        error.response.data.non_field_errors.forEach((err_msg) => {
          toast({
            title: err_msg,
            status: "error",
          });
        });
      }
    }
  };

  return (
    <Modal
      scrollBehavior={scrollBehavior}
      isOpen={state.isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign={"center"}>Servis Kaydı Oluştur</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {services.map((service, index) => (
            <Card key={index} mb={2}>
              <CardBody>
                <FormControl as={GridItem} colSpan={[6, 3]}>
                  <FormLabel
                    htmlFor="country"
                    fontSize="sm"
                    fontWeight="md"
                    color="gray.700"
                    _dark={{
                      color: "gray.50",
                    }}
                  >
                    Ürün
                  </FormLabel>
                  <Select
                    placeholder="Arızalı ürünü seçiniz"
                    value={service.product}
                    onChange={(e) =>
                      handleChangeService(index, "product", e.target.value)
                    }
                  >
                    {productOptions.map((option) => (
                      <option key={option.url} value={option.url}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl as={GridItem} colSpan={6}>
                  <FormLabel
                    htmlFor="country"
                    fontSize="sm"
                    fontWeight="md"
                    color="gray.700"
                    _dark={{
                      color: "gray.50",
                    }}
                  >
                    İşlem Tipi
                  </FormLabel>
                  <Select
                    placeholder="İşlem tipi seçiniz"
                    value={service.type}
                    onChange={(e) =>
                      handleChangeService(index, "type", e.target.value)
                    }
                  >
                    <option value="renovation">Tamir/onarım</option>
                    <option value="replacement">Yeni ürün değişimi</option>
                  </Select>
                </FormControl>
                <FormControl as={GridItem} colSpan={[6, 3, null, 2]}>
                  <FormLabel
                    htmlFor="postal_code"
                    fontSize="sm"
                    fontWeight="md"
                    color="gray.700"
                    _dark={{
                      color: "gray.50",
                    }}
                    mt="2%"
                  >
                    Açıklama
                  </FormLabel>
                  <Textarea
                    placeholder="Ürün arızasını detaylı şekilde açıklayın"
                    rows={3}
                    value={service.body}
                    onChange={(e) =>
                      handleChangeService(index, "body", e.target.value)
                    }
                    fontSize={{
                      sm: "sm",
                    }}
                  />
                </FormControl>
                {index > 0 && (
                  <Button
                    colorScheme="red"
                    size="sm"
                    onClick={() => handleRemoveService(index)}
                    mt={2}
                  >
                    {" "}
                    -{" "}
                  </Button>
                )}
              </CardBody>
            </Card>
          ))}
          <Button
            width={"100%"}
            mt={2}
            fontWeight={"900"}
            bgColor={"teal.100"}
            onClick={handleAddService}
          >
            {" "}
            +{" "}
          </Button>
          {errorData.task &&
            errorData.task.map((e) => (
              <Text key={e} color="red">
                {e}
              </Text>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Vazgeç
          </Button>
          <Button isLoading={loading} colorScheme="teal" onClick={handleSubmit}>
            Oluştur
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
